import { get, writable } from 'svelte/store';
import { navigate } from '../../app.logic';
import { LeadService } from '../../services/lead.service';
import { getCustomFieldSchemas, initializeCustomFields, makeTableCustomFields } from '../../utils/CustomFieldEntities/custom-field-utils';
import { ActivityService } from '../../services/activity.service';
export const loading = writable(false);
export const filter = writable({ criteria: {} });
export const records = writable([]);
export const pagination = writable(null);
export const record = writable(null);
export const stats = writable(null);
export const comments = writable([]);
export const activities = writable([]);
export const channels = writable([]);
export const customFieldsSchemas = writable([]);
export const tableCustomFields = writable([]);
export async function initList() {
    filter.set({ criteria: {}, params: null, sorting: "" });
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    record.set(null);
    await loadCustomFieldSchemas();
    await load();
}
export async function initDetail(oid) {
    record.set(null);
    stats.set(null);
    channels.set([]);
    activities.set([]);
    await loadCustomFieldSchemas();
    if (oid == 0) {
        let tmpRecord = { oid: 0 };
        tmpRecord.customFields = initializeCustomFields(get(customFieldsSchemas));
        record.set(tmpRecord);
    }
    else {
        let _resp = await LeadService.fetchLead(oid).toPromise();
        record.set(_resp.payload);
        await loadStats(oid);
        await loadChannels(oid);
        await loadActivities(oid);
    }
}
async function loadCustomFieldSchemas() {
    let schemas = await getCustomFieldSchemas("LEADXXXXXX");
    customFieldsSchemas.set(schemas);
    let tcf = await makeTableCustomFields(schemas, 'lead');
    tableCustomFields.set(tcf);
}
async function loadStats(customerOid) {
    // let _resp = await LeadService.fetchLeadStats(customerOid).toPromise();
    // stats.set(_resp.payload);
}
export async function search() {
    pagination.set({ currentPage: 1, totalPages: 0, totalRecords: 0 });
    await load();
}
export async function clearSearch() {
    resetSearchFilter();
    search();
}
export function resetSearchFilter() {
    filter.set({ criteria: {}, params: null, sorting: "" });
}
export async function load() {
    loading.set(true);
    try {
        let _filter = get(filter);
        let _pag = get(pagination);
        let _resp = await LeadService.getLeads(_filter, _pag.currentPage).toPromise();
        records.set(_resp.payload);
        pagination.set(_resp.pagination);
    }
    finally {
        loading.set(false);
    }
}
export function onCreate() {
    navigate(`/lead/0`);
}
export function onEdit(item) {
    navigate(`/lead/${item.oid}`);
}
export async function save() {
    let _record = get(record);
    return LeadService.saveLead(_record).toPromise();
}
export async function onDelete(item) {
    await LeadService.deleteLead(item.oid).toPromise();
    await load();
}
export function onPageChange(pageNumber) {
    pagination.set(Object.assign(Object.assign({}, get(pagination)), { currentPage: pageNumber }));
    load();
}
// ----------------------------------------------------------------------
// Activities
// ----------------------------------------------------------------------
export async function loadActivities(companyId) {
    let _resp = await ActivityService.getOpenActivities(companyId, 'Lead').toPromise();
    activities.set(_resp.payload);
}
export async function addActivity(event) {
    let act = event.detail;
    await ActivityService.saveActivity(act).toPromise();
    loadActivities(act.entityId);
}
export async function completeActivity(event) {
    let act = event.detail;
    await ActivityService.completeActivity(act.oid).toPromise();
    loadActivities(act.entityId);
}
// ----------------------------------------------------------------------
// Comments
// ----------------------------------------------------------------------
export async function loadComments(oid) {
    let _resp = await LeadService.getLeadComments(oid).toPromise();
    comments.set(_resp.payload);
}
export async function addComment(event) {
    let comment = event.detail;
    await LeadService.saveLeadComment(comment).toPromise();
    loadComments(comment.entityId);
}
export async function delComment(event) {
    let comment = event.detail;
    await LeadService.deleteLeadComment(comment.oid).toPromise();
    loadComments(comment.entityId);
}
// ----------------------------------------------------------------------
// Channels
// ----------------------------------------------------------------------
export async function loadChannels(leadId) {
    let _resp = await LeadService.getLeadChannels(leadId).toPromise();
    channels.set(_resp.payload);
}
export async function addChannel(event) {
    let channel = event.detail;
    await LeadService.saveLeadChannel(channel).toPromise();
    loadChannels(channel.entityId);
}
export async function delChannel(event) {
    let channel = event.detail;
    await LeadService.deleteLeadChannel(channel.oid).toPromise();
    loadChannels(channel.entityId);
}
